import { FC } from "react";
import { Tag } from "@design-system/Tag/Tag";
import styles from "./Commands.module.scss";
import { COMMAND_DIRECTORY_LABELS, CommandsDirectory } from "./lib";

interface Props {
    directories: CommandsDirectory[];
    /** Shown instead of the current directory's label. */
    label?: string;
}

export const CommandsDirectoryBreadcrumbs: FC<Props> = ({
    directories,
    label,
}) => (
    <aside className={styles.breadcrumbs}>
        <Tag
            key={directories[directories.length - 1]}
            size="sm"
            color="neutral"
            outline
        >
            {label ??
                COMMAND_DIRECTORY_LABELS[directories[directories.length - 1]]}
        </Tag>
    </aside>
);
